var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.error && _vm.getData.length > 0)?_c('div',{staticClass:"barra-acesso"},[_c('Carousel',{ref:"nav",attrs:{"autoplay":true,"nav":true,"dots":false,"items":4,"responsive":{
      0: {
        items: 1,
        nav: false,
      },
      360: {
        items: 2,
        nav: false,
      },
      600: {
        items: 3,
        nav: false,
      },
      900: {
        items: 4,
        nav: false,
      },
    }}},[_c('template',{slot:"prev"},[_c('div',{staticClass:"ba-prev"},[_c('span',{staticClass:"prev"},[_vm._v("‹")])])]),_vm._l((_vm.getData),function(item,idx){return _c('Card',{key:idx,attrs:{"data":item}})}),_c('template',{slot:"next"},[_c('div',{staticClass:"ba-next"},[_c('span',{staticClass:"next"},[_vm._v("›")])])])],2)],1):_c('div',{staticClass:"barra-acesso-not-found"})}
var staticRenderFns = []

export { render, staticRenderFns }